import { Loader2 } from "lucide-react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "@/lib/auth";

// Wrap the /login route. Already-authenticated users get bounced to either
// `?next=<path>` (preserved across the redirect) or `/`.
export function RedirectIfAuthed() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="flex h-full min-h-screen items-center justify-center bg-background text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" aria-label="Loading" />
      </div>
    );
  }

  if (status === "authed") {
    const params = new URLSearchParams(location.search);
    const next = params.get("next");
    const target = next && next.startsWith("/") ? next : "/";
    return <Navigate to={target} replace />;
  }

  return <Outlet />;
}
